import { createFileRoute } from '@tanstack/react-router'
import CreateTemplate from '@/features/admin/templates/create'

export const Route = createFileRoute('/_admin/admin/templates/create/')({
  component: CreateTemplate,
})
